module.exports = __webpack_public_path__ + "themes/mf/font/proximasoft-regular-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/font/proximasoft-regular-webfont.eot
// module id = 142
// module chunks = 3